import React from "react";

interface LabelItem {
    id: string;
    title: string;
    icon?: React.ReactNode;
}

interface LabelProps {
    list: LabelItem[];
    onDelete: (id: string) => void;
    size?: "lg" | "md";
}

const Label: React.FC<LabelProps> = ({ list, onDelete, size = "md" }) => {
    const sizeMap = {
        "lg": "h-[46px] pl-[17px] pr-[17px]",
        "md": "h-[35px] pl-[17px] pr-[0px]",
    };

    const Icon: React.FC<{ icon?: React.ReactNode }> = ({ icon }) => (
        icon ? (
            <div className="text-black-500 flex justify-center items-center">
                {icon}
            </div>
        ) : null
    );

    const MemoizedIcon = React.memo(Icon);

    return (
        <>
            {list.map((labelItem) => (
                <div
                    className={`
            rounded-full inline-flex justify-start items-center transition bg-gray-200 w-max group cursor-pointer gap-sm ${labelItem.icon ? '!pl-[2.5px]' : ''}
            ${sizeMap[size]}
          `}
                    key={labelItem.id} // Changed from index to labelItem.id for more stable keys
                >
                    <MemoizedIcon icon={labelItem.icon} />
                    <span className={"text-gray-900 cursor-default capitalize"}>{labelItem.title}</span>

                    <span onClick={() => onDelete(labelItem.id)}>
                    {' '}
                        <svg
                            className={`cursor-pointer text-[14px] text-gray-400 hover:text-gray-700 transition w-[15px] h-[15px] flex justify-center items-center mr-[6px]`}
                            height="1.22em"
                            width="1.22em"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 864 864"
                        >
                      <path
                          className="cls-1"
                          d="M432,0C193.41,0,0,193.41,0,432s193.41,432,432,432,432-193.41,432-432S670.59,0,432,0Zm192,569.11c17.57,17.57,17.57,46.07,0,63.64-8.79,8.79-20.3,13.18-31.82,13.18s-23.03-4.39-31.82-13.18l-137.11-137.11-137.11,137.11c-8.79,8.79-20.3,13.18-31.82,13.18s-23.03-4.39-31.82-13.18c-17.57-17.57-17.57-46.07,0-63.64l137.11-137.11-137.11-137.11c-17.57-17.57-17.57-46.07,0-63.64s46.07-17.57,63.64,0l137.11,137.11,137.11-137.11c17.57-17.57,46.07-17.57,63.64,0,17.57,17.57,17.57,46.07,0,63.64l-137.11,137.11,137.11,137.11Z"
                      />
                    </svg>
                  </span>
                </div>
            ))}
        </>
    );
};

export default React.memo(Label);
